<template>
    <div class="text-center">
        <img v-if="src" width="250" :src="src" alt="Profile Photo"/>
        <div v-else class="image-placeholder">
            No Profile Photo
        </div>
    </div>
    <div class="text-right">
        <input
            @change="handleLogoFileChange"
            type="file"
            ref="file"
            class="file"
            accept="image/*"
        />

        <div class="btn-group btn-group-sm mt-3" role="group">
            <button @click="$refs.file.click(e)" type="button" class="btn btn-info">
                <i class="fa fa-folder"></i> Upload
            </button>
            <button @click="handleLogoRemove" type="button" class="btn btn-xs btn-danger">
                <i class="fa fa-times"></i> Remove
            </button>
        </div>
    </div>
</template>

<script>
import {ref, watch} from "vue";

export default {
    name: "ImageUpload",
    emits: [
        'uploaded',
        'removed'
    ],
    props: {
        imageSrc: String
    },
    setup(props, {emit}) {
        const src = ref(props.imageSrc);

        const handleLogoFileChange = async (event) => {
            const file = event.target.files[0];
            src.value = await readFile(file);

            emit('uploaded', file);
        }

        const handleLogoRemove = () => {
            src.value = '';
            emit('removed');
        }

        const readFile = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });

        watch(() => props.imageSrc, (value) => src.value = value)

        return {
            src,
            handleLogoFileChange,
            handleLogoRemove
        };
    }
}
</script>

<style scoped lang="scss">
.file {
    visibility: hidden;
    position: absolute;
}

.image-placeholder {
    padding: 20px 0;
}
</style>